import {MatrixEvent, Room} from 'matrix-js-sdk';
export const getLastMessage = (room: Room): MatrixEvent | null => {
  const allMessages = room.getLiveTimeline().getEvents();
  if (allMessages.length > 0) {
    return allMessages[allMessages.length - 1];
  }
  return null;
};
